export default {
  data: {
    darkMode: 'false' as string,
    langs: [
      { code: 'en', name: 'English' },
      { code: 'fr', name: 'Français' },
      { code: 'cn', name: '简体中文' },
      { code: 'tw', name: '繁體中文' },
    ],
  },
};
